
import { defineComponent } from 'vue'
import { SearchBox } from '../../shared'
import ExplainSearchBoxBase from '../explain-search-box-base.component.vue'

export default defineComponent({
  name: 'ExplainProductAnalysisSearchBox',
  components: {
    SearchBox,
    ExplainSearchBoxBase,
  },
  props: {
    inputQuery: {
      type: String,
      default: '',
    },
  },
  setup() {
    return {
      baseClass: 'epb-explain-product-analysis-search-box',
    }
  },
})
